import React, { useContext } from "react";

export interface ServiceWorketContextValue {
  register: () => Promise<void>;
  waitForInstalled: () => Promise<void>;
}

export const ServiceWorkerContext =
  React.createContext<ServiceWorketContextValue>({
    register: () => Promise.resolve(),
    waitForInstalled: () => Promise.resolve(),
  });

export function useServiceWorkerContext() {
  return useContext(ServiceWorkerContext);
}
